import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import moment from 'moment'
import {SlideDown} from 'react-slidedown'
import config from '../../config'
// import format from '../../helpers/format'
import analytics from '../../helpers/analytics'
import {
  Link,
  LinkIcon
} from '../../components'
import Styles from './Changelog.css'

/**
 * A single item in the change log.
 */
@CSSModules(Styles, {allowMultiple:true})
class ChangelogItem extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    idx: PropTypes.number.isRequired,
  }
  //
  constructor(props){
    super(props)
  }
  //
  render() {
    const { id, content, idx } = this.props
    const dt = moment(id).format('MMM D, YYYY')
    // const urlBase = 'https://www.asyousow.org/invest-your-values/download-data'
    return <div styleName='changelog-item' key={'clgitm' + idx}>
      <div styleName='changelog-item-title'>
        {
          idx===0 ?
            <span>Current dataset: {dt}</span> :
            dt
        }
      </div>
      <div styleName='changelog-item-content'>
        <strong>Description:</strong> { content }
      </div>
      { /* <div styleName='changelog-item-links'>
        <div styleName='changelog-item-link'>
          <Link
            to={urlBase+'?company='+id}
            title={'Invest Your Values company screens download '+id}
            log={analytics.eventDownloadChangelogExcel(id + ' company screens')}
            xstrong
          >
            Company lists { id }
            <LinkIcon faclass='fa-download'/>
            <LinkIcon faclass='fa-file-excel-o'/>
          </Link>
        </div>
        <div styleName='changelog-item-link'>
          <Link
            to={urlBase+'?shareclass='+id}
            title={'Invest Your Values shareclass results download '+id}
            log={analytics.eventDownloadChangelogExcel(id + ' shareclass results')}
            xstrong
          >
            Shareclass results { id }
            <LinkIcon faclass='fa-download'/>
            <LinkIcon faclass='fa-file-excel-o'/>
          </Link>
        </div>
      </div> */ }
    </div>
  }
}

/**
 * A component to display a list of changelog items.
 * The first item is always displayed; other items are displayed if the user
 * clicks a button.
 */
@CSSModules(Styles, {allowMultiple:true})
export default class Changelog extends Component {
  constructor(props){
    super(props)
    this.state = {
      open: false
    }
  }
  //
  openSlidedown = () => {
    this.setState({ open: true })
  }
  //
  render() {
    return <div styleName='changelog-wrap'>
      <div styleName='changelog-title'>
        Changelog
      </div>
      <div styleName='changelog-info'>
        <p>
          Changes to the company lists or fund rating methodologies will be
          reflected below.
        </p>
        <p>
          Spreadsheet downloads for the Invest Your Values mutual fund and
          ETF scorecards will be hosted exclusively on
          the <Link to='https://asyouknow.com/' title='As You Know'
          xstrong>As You Know</Link> data platform beginning in early 2026.
          For ongoing access and updates, please
          contact <Link to='mailto:data@asyouknow.com'
            xstrong>data@asyouknow.com</Link>.
        </p>

      </div>
      <ChangelogItem id={config.changelog[0].id} content={config.changelog[0].content} idx={0}/>
      {
        !this.state.open ?
          <button
            styleName='changelog-open-button'
            onClick={this.openSlidedown}
          >
            See older<LinkIcon faclass='fa-caret-down'/>
          </button> :
          null
      }
      <SlideDown>
        {
          this.state.open ?
            config.changelog.slice(1).map((c, idx) => {
              return <ChangelogItem id={c.id} content={c.content} idx={idx+1}/>
            }) :
            null
        }
      </SlideDown>
    </div>
  }
}
